import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { DeepPartial } from 'utility-types';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import { select } from '@swf/core/store';
import type { WizardContext } from '@swf/core/types/Wizard';

import type { DepositPayload } from '../types/Cashier';

type WizardJump = (target: string) => void;

const useJumpBackAndResetDeposit = (): WizardJump => {
  const wizardContext = useWizardContext() as WizardContext;
  const isReloader = useSelector(select.account.isReloader);
  const { jumpBack } = useWizardJump();

  return useCallback(
    (target: string) => {
      const { deposit } = wizardContext.values;
      const resetValues: DeepPartial<DepositPayload> = {};

      if (!isReloader) {
        deposit.bonusCode && (resetValues.bonusCode = deposit.bonusCode);
        deposit.bonusAcknowledged && (resetValues.bonusAcknowledged = deposit.bonusAcknowledged);
      }

      wizardContext.values.deposit = resetValues;
      delete wizardContext.data.savedCardInfoId;

      return jumpBack(target);
    },
    [isReloader, jumpBack, wizardContext.data.savedCardInfoId, wizardContext.values]
  );
};

export default useJumpBackAndResetDeposit;
